import type { ReactNode } from 'react';

// Section icon-header (icon box + title + subtitle) — extracted from the
// pattern originally inline in CategoryFormPage, now the shared vocabulary
// every CCCD admin form section uses (cccd-ux-redesign, cccd-admin-design-system).
export function SectionHeader({
  icon,
  title,
  subtitle,
  badge,
  children,
  className = '',
}: {
  icon: ReactNode;
  title: string;
  subtitle: ReactNode;
  /** Optional pill/status rendered at the far right of the header row (e.g. a computed "Dura 3 días"). */
  badge?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={`rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03] ${className}`}>
      <div className="mb-[18px] flex items-start justify-between gap-2.5">
        <div className="flex gap-2.5">
          <div className="flex size-[34px] shrink-0 items-center justify-center rounded-[9px] bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400">
            {icon}
          </div>
          <div>
            <h3 className="text-base font-semibold text-gray-800 dark:text-white/90">{title}</h3>
            <p className="mt-px text-[13px] text-gray-500 dark:text-gray-500">{subtitle}</p>
          </div>
        </div>
        {badge}
      </div>
      {children}
    </section>
  );
}
